module.exports = __webpack_public_path__ + "static/media/blom-a-generative-art-series-by-lucastswick-thumb-62.8080f7ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-archive/blom-a-generative-art-series-by-lucastswick-thumb-62.jpg
// module id = 3624
// module chunks = 15